module.exports = __webpack_public_path__ + "img/python.4fb5a090.png";